import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { Link } from "react-router-dom";
import Tr from "../../../../subtestsetting/tr";

import {
  ModalHeader,
  ModalContents,
  ModalFooter
} from "../../../../common/modal";

class TREdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editSaving: false,
      errors: {},
      selected: {},
      error: null,
      modalOpen: false,
      showTestCreationCancelConfirmation: false,
      selectedTrResult: null,
      subTestTargetResult: []
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.props.handleClose(this.props.selectedTest);
  }

  testCreationClose = () => {
    this.setState({ showTestCreationCancelConfirmation: true });
  };

  onTestCreationCancelConfirm = () => {
    this.props.handleClose(this.props.selectedTest);
  };

  hideTestCreationCancelConfirm = () => {
    this.setState({ showTestCreationCancelConfirmation: false });
  };

  selectedRows = rows => {
    this.setState({
      selected: rows
    });
  };
  render() {
    const { translate, classes, selectedTest, testEdit, modified } = this.props;
    let { targetList } = this.props;
    const {
      showTestCreationCancelConfirmation,
      selectedTrResult,
      subTestTargetResult
    } = this.state;
    return selectedTest && selectedTest.length ? (
      <Modal
        open={true}
        onClose={this.handleClose}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography
                type="headline"
                color="inherit"
                className={classes.modalHeader}
              >
                {testEdit
                  ? translate("test_edit_title").toUpperCase()
                  : translate("test_add").toUpperCase()}
              </Typography>
              <Button
                className={classes.close}
                onClick={this.testCreationClose}
              >
                <Icon> clear </Icon>
              </Button>
            </ModalHeader>
            <Typography
              type="headline"
              color="inherit"
              className={classes.modalHeader}
              style={{ marginLeft: "20px" }}
            >
              {selectedTest === "traceroute4"
                ? translate("general_sub_test_tr4")
                : translate("general_sub_test_tr6")}
            </Typography>
            <ModalContents className={classes.rootModal}>
              <Tr
                selectedTest={selectedTest}
                translate={this.props.translate}
                selectedTrResult={selectedTrResult}
                subTestTargetResult={subTestTargetResult}
                getTrDetails={this.props.getTrDetails}
                updateTrDetails={this.props.updateTrDetails}
                getPingTargetList={this.props.getPingTargetList}
                handleClose={this.handleClose}
                isTestEdit={true}
                traceroute6Details={this.props.traceroute6Details}
                traceroute4Details={this.props.traceroute4Details}
                deleteDefaultSubtests={this.props.deleteDefaultSubtests}
                showTestCreationCancelConfirmation={
                  showTestCreationCancelConfirmation
                }
                onTestCreationCancelConfirm={this.onTestCreationCancelConfirm}
                hideTestCreationCancelConfirm={
                  this.hideTestCreationCancelConfirm
                }
                customerId={this.props.customerId}
                testEdit={testEdit}
                modified={modified}
              />
            </ModalContents>
          </Paper>
        </div>
      </Modal>
    ) : null;
  }
  componentWillReceiveProps(nextProps) {
    const { selectedTrResult, subTestTargetResult } = nextProps;
    if (selectedTrResult && this.props.selectedTrResult != selectedTrResult) {
      this.setState({ selectedTrResult });
    }
    if (
      subTestTargetResult &&
      this.props.subTestTargetResult != subTestTargetResult
    ) {
      this.setState({ subTestTargetResult });
    }
  }
}

export default withStyles(styles)(TREdit);
